import GjwSearch from './src/GjwSearch'

GjwSearch.install = function(Vue) {
  Vue.component(GjwSearch.name, GjwSearch)
}

export default GjwSearch
